import {Injectable} from '@angular/core';

import {MapLayerType} from "@src/app/map/map-layers";

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  private static readonly skipWelcomeLSKey = 'skip-welcome';
  private static readonly previouslySelectedDatabaseLSKey = 'previously-selected-database';
  private static readonly machineIdLSKey = 'machine-id';
  private static readonly mapLayerLSKey = 'map-layer';
  private static readonly loggedUserEmailLSKey = 'email';
  private static readonly showPopupsLSKey = 'show-popups'

  constructor() {
  }

  setLoggedUserEmail(email: string) {
    localStorage.setItem(SettingsService.loggedUserEmailLSKey, email);
  }

  getLoggedUserEmail(): string | null {
    return localStorage.getItem(SettingsService.loggedUserEmailLSKey);
  }

  isSkipChooseLoginMethod(): boolean {
    return localStorage.getItem(SettingsService.skipWelcomeLSKey) !== null;
  }

  setSkipChooseLoginMethod() {
    localStorage.setItem(SettingsService.skipWelcomeLSKey, '');
  }

  getPreviouslySelectedDatabase(): string | null {
    return localStorage.getItem(SettingsService.previouslySelectedDatabaseLSKey);
  }

  setPreviouslySelectedDatabase(database: string) {
    localStorage.setItem(SettingsService.previouslySelectedDatabaseLSKey, database);
  }

  setMachineId(): string {
    const id = this.getGuid();
    localStorage.setItem(SettingsService.machineIdLSKey, JSON.stringify(id));
    return id;
  }

  getMachineId(): string {
    const id = localStorage.getItem(SettingsService.machineIdLSKey);
    return id ? id : this.setMachineId();
  }

  setMapLayer(mapLayer: MapLayerType) {
    localStorage.setItem(SettingsService.mapLayerLSKey, mapLayer.toString());
  }

  getMapLayer(): MapLayerType | null {
    const item = localStorage.getItem(SettingsService.mapLayerLSKey);
    return item ? +item as MapLayerType : null;
  }

  isShowPopups(): boolean {
    const item = localStorage.getItem(SettingsService.showPopupsLSKey);
    return item == null ? true : item === 'true';//domyślnie ta opcja jest włączona dopóki nie zostanie wykonana zmiana i zapis
  }

  setShowPopups(isShown: boolean) {
    localStorage.setItem(SettingsService.showPopupsLSKey, isShown.toString());
  }

  private getGuid(): string {
    let d = new Date().getTime();
    let d2 = (performance && performance.now && (performance.now() * 1000)) || 0;

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      let r = Math.random() * 16;
      if (d > 0) {
        r = (d + r) % 16 | 0;
        d = Math.floor(d / 16);
      } else {
        r = (d2 + r) % 16 | 0;
        d2 = Math.floor(d2 / 16);
      }
      return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16);
    });
  };

}
